// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

// Services
import petOrderService from '@/app/services/main/pet-order/pet-order-service.js';

// Constants
import { STATUS_CODES, SUBSCRIPTION_PERIOD, STATUS } from '@/app/constants/constants';

export default {
	name: 'DogPurchaseContainer',
	mixins: [ 
		tableMixins, 
		productMixins, 
		toastMessageMixins 
	],
	data() {
		return {
			subPeriod: SUBSCRIPTION_PERIOD,
			isAPILoading: true,
			modalContent: {},
			// table
			theads: [
				{ name: 'Image', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'max-width: 150px;'},
				{ name: 'Breed', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
				{ name: 'Price', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
				{ name: 'Store Credit', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
				{ name: 'Customer', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasStatusSearch: true, style: 'min-width: 120px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null}
			],
			// sorting
			desc: true,
			storeCredit: 0.00
		} 
	},
	props: {
		isDashboard: {
			type: Boolean,
			default: false
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getPurchaseList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_status) {
					queryParams['f_status'] = this.columnsFilter.f_status;
				}
			}

			this.isAPILoading = true;

			petOrderService.getPetPurchase(queryParams)
				.then(res => {	
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
						this.storeCredit = res.data.storeCredit.price;

						this.isAPILoading = false;
					} else {
						this.showAPIErrorToast('Unable to fetch product list.', res);
						this.isAPILoading = false;
					}
				});
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
			this.getPurchaseList({ page, limit, sortBy, desc });
		},
		hasProductImage(productImage) {
			let image = require('@/assets/images/temporary/product-image.png');

			if (productImage) {
				image = productImage;
			}

			return image;
		},
		getPrice(list){
                let totalPrice = null;

                list.products.map(product => { 
                    if(product.productType.id === 6) totalPrice = product.price;
                });

                return totalPrice;
        },
		getStore(list){
			let storeCredit = null;
			
			if (list.status === 'P') {
				storeCredit = this.storeCredit;
			} else {
				list.products.map(product => { 
					if(product.productType.id === 7) storeCredit = product.price;
				});
			}

			return storeCredit;
		},
		displayStatus(status) {
            return STATUS[status];
        },
		showPurchaseDetailsModal(data) {
			if(data.bundleId){
				this.$router.push(`/dog-purchase/view/${data.id}`);
			}else{
				this.$router.push(`/dog-purchase/request/${data.id}`);
			}
		}
	}
}